import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { BuildBuyEvaluationRow } from './useBuildBuyEvaluation';

/**
 * Fetches the extra rows needed to build the full project PDF export
 * that are not already fetched by AdminProjectDetailPage hooks.
 */
export function useProjectFullExport(projectId: string | undefined, userId: string | undefined) {
  return useQuery({
    queryKey: ['project-full-export', projectId, userId],
    enabled: !!projectId,
    queryFn: async () => {
      const [delivRes, bbRes, sugRes] = await Promise.all([
        userId
          ? supabase
              .from('participant_deliverables')
              .select('*')
              .eq('user_id', userId)
              .order('submitted_at', { ascending: false })
          : Promise.resolve({ data: [], error: null } as any),
        supabase
          .from('build_buy_evaluations' as any)
          .select('*')
          .eq('project_id', projectId!)
          .order('created_at', { ascending: false })
          .limit(1),
        supabase
          .from('project_suggestions')
          .select('*')
          .eq('project_id', projectId!)
          .order('created_at', { ascending: false }),
      ]);

      if (delivRes.error) throw delivRes.error;
      if (bbRes.error) throw bbRes.error;
      if (sugRes.error) throw sugRes.error;

      return {
        deliverables: (delivRes.data || []) as any[],
        buildBuy: ((bbRes.data || [])[0] as unknown as BuildBuyEvaluationRow) || null,
        suggestions: (sugRes.data || []) as any[],
      };
    },
  });
}
